import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useRouting() {
  const route = useRoute();

  const routeMetadata = computed(() => {
    return route.meta || {};
  });

  const routePrefix = computed(() => {
    return routeMetadata.value.prefix || '';
  });

  const routePageName = computed(() => {
    if (!route.name || typeof route.name !== 'string') {
      return undefined;
    }
    return route.name.split('-')[0];
  });

  const getLanguageSwitchLink = (language: HgSupportedLanguage) => {
    if (typeof route.meta?.getLanguageSwitchLink === 'function') {
      return route.meta?.getLanguageSwitchLink(route, language);
    }
  };

  const getPageRoute = (
    pageName: string,
    language: HgSupportedLanguage,
    options?: any,
    ignorePrefix = false,
  ) => {
    return {
      name: `${pageName}-${language}${ignorePrefix ? '' : routePrefix.value}`,
      ...options,
    };
  };

  return {
    routeMetadata,
    routePrefix,
    routePageName,
    getLanguageSwitchLink,
    getPageRoute,
  };
}
